var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VHeader',{attrs:{"user":_vm.user}}),_c('truck-scanner',{attrs:{"truckId":_vm.truckId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }